export default {
    init() {
        document.addEventListener("touchstart", function() {},false);

        var btn_nl = $('.btn-newsletter');
        $(document).on('click', '.menu-btn', function (e) {
            e.preventDefault();
            $(this).toggleClass('active');
            $('.nav-primary').toggleClass('open');
            $('body').toggleClass('menu-open');
        });

        //Mobile
        // if( $(window).width() < 768 ){
        //     $(document).on('click', '.nav-primary a', function (e) {
        //         $(this).toggleClass('clicked');
        //     });
        // }


        //Carousel init
        var carousel = $('.carousel');
        if (carousel.length) {
            $('.carousel').bcSwipe({ threshold: 50 });
            carousel.carousel({
                interval: 4500,
                keyboard: true,
                ride: false,
            });
        }

        if( $('.row-conference').length ){
            $('.row-conference .row-conference--link').on('click', function(){
                $(this).parents('.row-conference').toggleClass('open');
            });
        }

        if( $('a[data-scrollto]').length ){
            $('a[data-scrollto]').on('click', function(e){
               e.preventDefault();
                var $queriedItem = $(this).attr('data-scrollto');
                if( $queriedItem ){
                    $('html, body').animate({
                        scrollTop: $($queriedItem).offset().top-120,
                    }, 600);
                }
            });
        }

        if(window.location.hash.length > 0 && window.location.hash.indexOf('#') !== -1){
            var $queriedItem = $(window.location.hash);
            if( $queriedItem.length ){
                $('html, body').animate({
                    scrollTop: $queriedItem.offset().top-120,
                }, 600);
            }
        }

        // Ajax Albums et videos
        if ($('body').hasClass('page-template-template-albums')) {
            jQuery(document).ready(function($) {
                function loadAlbums(filter = '', paged = 1) {
                    $.ajax({
                        url: ajaxurl,
                        type: 'POST',
                        data: {
                            action: 'get_albums',
                            nonce: $('#albums-container').data('nonce'),
                            filter: filter,
                            paged: paged,
                        },
                        success: function(response) {
                            $('#albums-container').html(response);
                            var pagination = $('#albums-container .post-pagination');
                            if (pagination.length) {
                                $('.post-pagination').replaceWith(pagination);
                            }
                        }
                    });
                }

                // Initial load
                loadAlbums();

                // Filter handling
                $('.masonry-filter').on('click', function(e) {
                    e.preventDefault();
                    $('.masonry-filter').removeClass('active');
                    $(this).addClass('active');
                    var filter = $(this).data('filter');
                    loadAlbums(filter, 1);
                });

                // Pagination handling
                $('#albums-container').on('click', '.post-pagination a', function(e) {
                    e.preventDefault();
                    var paged = $(this).attr('href').split('paged=')[1] || 1;
                    var filter = $('.masonry-filter.active').data('filter');
                    loadAlbums(filter, paged);
                });
            });
        }

        // Ajax Nouveautes Exposants
        if ($('body').hasClass('post-type-archive-nouveaute-exposant')) {
            jQuery(document).ready(function($) {
                const ONE_HOUR_MS = 3600000;

                function loadNouveautes(type = '', paged = 1) {
                    console.log('Loading nouveautes with type:', type, 'and page:', paged);

                    $.ajax({
                        url: ajaxurl,
                        type: 'POST',
                        data: {
                            action: 'get_nouveautes_exposants',
                            type: type,
                            paged: paged,
                        },
                        success: function(response) {
                            $('#nouveautes-container').html(response);
                            var pagination = $('#nouveautes-container .post-pagination');
                            if (pagination.length) {
                                $('#nouveautes-container .post-pagination').replaceWith(pagination);
                            }
                        }
                    });

                    // Enregistre l'état du filtre, la page et le timestamp dans le localStorage
                    localStorage.setItem('filterState', type);
                    localStorage.setItem('pagedState', paged);
                    localStorage.setItem('timestamp', Date.now());
                }

                // Vérifie si les données du localStorage sont valides
                var savedTimestamp = localStorage.getItem('timestamp');
                if (savedTimestamp && Date.now() - savedTimestamp > ONE_HOUR_MS) {
                    // Supprime les données si elles sont trop anciennes
                    localStorage.removeItem('filterState');
                    localStorage.removeItem('pagedState');
                    localStorage.removeItem('timestamp');
                }

                // Récupère les valeurs du localStorage
                var savedFilter = localStorage.getItem('filterState') || '';
                var savedPage = localStorage.getItem('pagedState') || 1;

                // Charge les nouveautes avec les valeurs enregistrées
                loadNouveautes(savedFilter, savedPage);

                // Update de la classe active des filtres
                if (savedFilter) {
                    $('.masonry-filter[data-filter="' + savedFilter + '"]').addClass('active');
                } else {
                    $('.masonry-filter:first').addClass('active');
                }

                $('.masonry-filter').on('click', function(e) {
                    e.preventDefault();
                    $('.masonry-filter').removeClass('active');
                    $(this).addClass('active');
                    var type = $(this).data('filter');
                    loadNouveautes(type, 1); // Recharge la première page du nouveau filtre
                });

                $('#nouveautes-container').on('click', '.post-pagination a', function(e) {
                    e.preventDefault();
                    var paged = $(this).attr('href').split('paged=')[1] || 1;
                    var type = $('.masonry-filter.active').data('filter');
                    loadNouveautes(type, paged);
                });
            });
        }
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js